import * as Scrivito from "scrivito";
import { Formik } from "formik";
import React, { useMemo } from "react";

import {
  useCurrentQuestionnaire,
  useIsMultipleQuestionnaireListStep,
} from "stores/wizardStore";

import { WizardQuestionnaire } from "./WizardQuestionnaire/WizardQuestionnaire";
import { getFormInitialValues } from "./WizardQuestionnaire/questionnaireHelpers";

export const WizardFormWrapper = Scrivito.connect(() => {
  const currentQuestionnaire = useCurrentQuestionnaire();
  const isMultipleQuestionnaireListStep = useIsMultipleQuestionnaireListStep();

  const { questions } = currentQuestionnaire;

  const initialValues = useMemo(
    () => getFormInitialValues(questions),
    [questions],
  );

  const currentPage = Scrivito.currentPage();

  return (
    <>
      {currentQuestionnaire && (
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          <WizardQuestionnaire
            currentQuestionnaire={currentQuestionnaire}
            isMultipleQuestionnaireListStep={isMultipleQuestionnaireListStep}
          />
        </Formik>
      )}
      {isMultipleQuestionnaireListStep && (
        <Scrivito.ContentTag
          content={currentPage}
          attribute="roomcontrolPopup"
          tag="div"
        />
      )}
    </>
  );
});
